var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CustomModal",
    { staticClass: "page-editor-modal", attrs: { id: _vm.id } },
    [
      _c(
        "div",
        {
          staticClass: "container-fluid",
          attrs: { slot: "modal-header" },
          slot: "modal-header"
        },
        [
          _c("div", { staticClass: "row btn-row" }, [
            _c("div", { staticClass: "col-12" }, [
              _c("div", { staticClass: "page-editor-header mx-auto" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-6" }, [
                    _c(
                      "h5",
                      {
                        staticClass:
                          "action-header typography--headline typography--color-secondary"
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(
                              _vm.$t("page_editor.header." + _vm.pageType)
                            ) +
                            "\n              "
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-6" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-outline-primary float-right",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            return _vm.close()
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.$t("common.close")) +
                            "\n              "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _vm.pageType === "non_quiz"
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-primary float-right",
                            attrs: {
                              type: "button",
                              disabled: _vm.addQuizDisabled
                            },
                            on: {
                              click: function($event) {
                                return _vm.addNonQuiz()
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.$t("common.complete")) +
                                "\n              "
                            )
                          ]
                        )
                      : _c(
                          "button",
                          {
                            staticClass: "btn btn-primary float-right",
                            attrs: {
                              type: "button",
                              disabled: _vm.addQuizDisabled
                            },
                            on: {
                              click: function($event) {
                                return _vm.addQuiz()
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.$t("common.complete")) +
                                "\n              "
                            )
                          ]
                        )
                  ])
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row editor-toolbar-row" }, [
            _c("div", { staticClass: "col-12" }, [
              _c(
                "div",
                { staticClass: "mw-620 mx-auto" },
                [
                  _c("EditorToolbar", {
                    on: {
                      "image-added": _vm.onImageAdded,
                      "audio-added": _vm.onAudioAdded,
                      "show-add-video-modal": _vm.showAddVideoModal
                    }
                  })
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _vm.audios.length > 0
            ? _c("div", { staticClass: "row editor-audio-row" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c(
                    "div",
                    { staticClass: "mw-620 mx-auto relative-position" },
                    [
                      _c("LcAudio", { attrs: { audio: _vm.audios[0] } }),
                      _vm._v(" "),
                      _c("div", { staticClass: "remove-audio-btn" }, [
                        _c("img", {
                          staticClass: "clickable",
                          attrs: {
                            src: "/static/images/score-guide-close.svg",
                            alt: "remove audio"
                          },
                          on: {
                            click: function($event) {
                              return _vm.audios.pop()
                            }
                          }
                        })
                      ])
                    ],
                    1
                  )
                ])
              ])
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "container page-editor-body" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12" }, [
            _c("div", { staticClass: "mw-620 mx-auto" }, [
              _vm.quiz
                ? _c(
                    "div",
                    { staticClass: "quiz-content-container" },
                    [
                      _c(
                        "h6",
                        {
                          staticClass:
                            "typography--body-1 typography--color-secondary"
                        },
                        [
                          _vm.pageType === "non_quiz"
                            ? _c("strong", [
                                _vm._v(
                                  _vm._s(_vm.$t("page_editor.non_quiz.title"))
                                )
                              ])
                            : _c("strong", [
                                _vm._v(
                                  _vm._s(_vm.$t("page_editor.question.title"))
                                )
                              ]),
                          _vm._v(" "),
                          !_vm.sourceEditAvaliable
                            ? _c(
                                "span",
                                { staticClass: "typography--caption" },
                                [_vm._v("(수정 불가)")]
                              )
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _c("hr"),
                      _vm._v(" "),
                      _c("BaseEditor", {
                        staticClass: "quiz-editor",
                        attrs: {
                          "editor-id": "quiz-editor-" + _vm.id,
                          "text-limit": 5000,
                          disabled: !_vm.sourceEditAvaliable,
                          placeholder:
                            _vm.pageType === "non_quiz"
                              ? _vm.$t("page_editor.non_quiz.placeholder")
                              : _vm.$t("page_editor.question.placeholder")
                        },
                        on: { error: _vm.checkContentError },
                        model: {
                          value: _vm.quiz.content,
                          callback: function($$v) {
                            _vm.$set(_vm.quiz, "content", $$v)
                          },
                          expression: "quiz.content"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.pageType === "multiple_choice"
                ? _c("div", { staticClass: "quiz-answers-container" }, [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-3" }, [
                        _c(
                          "h6",
                          {
                            staticClass:
                              "typography--body-1 typography--color-secondary"
                          },
                          [
                            _c("strong", [
                              _vm._v(
                                _vm._s(_vm.$t("page_editor.choices.title"))
                              )
                            ]),
                            _vm._v(" "),
                            !_vm.sourceEditAvaliable
                              ? _c(
                                  "span",
                                  { staticClass: "typography--caption" },
                                  [_vm._v("(수정 불가)")]
                                )
                              : _vm._e()
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-9" }, [
                        _c("div", { staticClass: "float-right" }, [
                          _c(
                            "small",
                            {
                              staticClass:
                                "typography--caption typography--color-secondary align-bottom"
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.$t("page_editor.choices.hint")) +
                                  "\n                  "
                              )
                            ]
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("hr"),
                    _vm._v(" "),
                    _c(
                      "div",
                      [
                        _vm._l(_vm.answers, function(answer, index) {
                          return _c(
                            "div",
                            {
                              key: _vm.getAnswerKey(answer),
                              style: _vm.sourceEditAvaliable
                                ? ""
                                : "pointer-events: none;"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "quiz-answer-box",
                                  class: {
                                    "has-error":
                                      answer.content &&
                                      answer.content.length > 499
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.answers.length > 2 &&
                                            _vm.getAnswerKey(answer) !==
                                              _vm.getAnswerKey(
                                                _vm.chosenAnswer
                                              ),
                                          expression:
                                            "answers.length > 2 && getAnswerKey(answer) !== getAnswerKey(chosenAnswer)"
                                        }
                                      ],
                                      staticClass:
                                        "delete-quiz-answer-btn clickable",
                                      on: {
                                        click: function($event) {
                                          return _vm.removeAnswer(index)
                                        }
                                      }
                                    },
                                    [
                                      _c("img", {
                                        attrs: {
                                          src: "/static/images/icon-delete.svg",
                                          alt: "delete quiz answer choice"
                                        }
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "quiz-choice-item-index float-left"
                                    },
                                    [_vm._v(_vm._s(index + 1) + ".")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "quiz-choice-editor" },
                                    [
                                      _c("AutosizeTextarea", {
                                        attrs: {
                                          placeholder: _vm.$t(
                                            "page_editor.choices.placeholder"
                                          )
                                        },
                                        model: {
                                          value: answer.content,
                                          callback: function($$v) {
                                            _vm.$set(answer, "content", $$v)
                                          },
                                          expression: "answer.content"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "quiz-choice-item-radio-box float-right"
                                    },
                                    [
                                      _c(
                                        "Radio",
                                        {
                                          attrs: {
                                            "model-value": _vm.chosenAnswer,
                                            "check-value": answer,
                                            id:
                                              "quiz-choice-item-radio-" +
                                              _vm.id +
                                              "-" +
                                              index,
                                            "left-label": "true"
                                          },
                                          on: {
                                            change: function($event) {
                                              return _vm.selectCorrectAnswerChoice(
                                                answer
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    _vm.getAnswerKey(
                                                      _vm.chosenAnswer
                                                    ) ===
                                                    _vm.getAnswerKey(answer),
                                                  expression:
                                                    "getAnswerKey(chosenAnswer) === getAnswerKey(answer)"
                                                }
                                              ],
                                              staticClass:
                                                "typography--body-3 typography--color-secondary",
                                              attrs: { slot: "left-label" },
                                              slot: "left-label"
                                            },
                                            [
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "page_editor.choices.is_correct"
                                                    )
                                                  ) +
                                                  "\n                      "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              answer.content && answer.content.length > 499
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "typography--caption typography--color-alert text-center pb-12"
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.$t(
                                              "page_editor.choices.alerts.max_length"
                                            )
                                          ) +
                                          "\n                "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.answers.length < 5,
                                expression: "answers.length < 5"
                              }
                            ],
                            on: {
                              click: function($event) {
                                return _vm.addNewAnswer()
                              }
                            }
                          },
                          [
                            _c("AddAnswerButton", [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(
                                    _vm.$t(
                                      "page_editor.choices.add_new.placeholder"
                                    )
                                  ) +
                                  "\n                "
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      2
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.pageType === "multiple_choice"
                ? _c("div", { staticClass: "quiz-view-type-container" }, [
                    _c(
                      "h6",
                      {
                        staticClass:
                          "typography--body-1 typography--color-secondary"
                      },
                      [
                        _c("strong", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("page_editor.choices.view_types.title")
                            )
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-sm-6" }, [
                        _c(
                          "div",
                          { staticClass: "quiz-view-type-box" },
                          [
                            _c("div", {
                              staticClass:
                                "quiz-view-type-img text-button-type-img"
                            }),
                            _vm._v(" "),
                            _c(
                              "Radio",
                              {
                                attrs: {
                                  "model-value": _vm.quiz.answer_view_type,
                                  "check-value": "list",
                                  id: "text-button-radio"
                                },
                                on: { change: _vm.selectAnswerViewType }
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "typography--body-3 typography--color-secondary",
                                    attrs: { slot: "label" },
                                    slot: "label"
                                  },
                                  [
                                    _vm._v(
                                      "\n                      " +
                                        _vm._s(
                                          _vm.$t(
                                            "page_editor.choices.view_types.text_button_type"
                                          )
                                        ) +
                                        "\n                    "
                                    )
                                  ]
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-6" }, [
                        _c(
                          "div",
                          { staticClass: "quiz-view-type-box" },
                          [
                            _c("div", {
                              staticClass:
                                "quiz-view-type-img number-button-type-img"
                            }),
                            _vm._v(" "),
                            _c(
                              "Radio",
                              {
                                attrs: {
                                  "model-value": _vm.quiz.answer_view_type,
                                  "check-value": "control",
                                  id: "number-button-radio"
                                },
                                on: { change: _vm.selectAnswerViewType }
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "typography--body-3 typography--color-secondary",
                                    attrs: { slot: "label" },
                                    slot: "label"
                                  },
                                  [
                                    _vm._v(
                                      "\n                      " +
                                        _vm._s(
                                          _vm.$t(
                                            "page_editor.choices.view_types.number_button_type"
                                          )
                                        ) +
                                        "\n                    "
                                    )
                                  ]
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _vm.hasLongAnswerChoices
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "typography--caption typography--color-alert text-center pt-12"
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.$t(
                                    "page_editor.choices.alerts.view_type_hint"
                                  )
                                ) +
                                "\n            "
                            )
                          ]
                        )
                      : _vm._e()
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.pageType === "text_entry"
                ? _c(
                    "div",
                    { staticClass: "quiz-answers-container" },
                    [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-3" }, [
                          _c(
                            "h6",
                            {
                              staticClass:
                                "typography--body-1 typography--color-secondary"
                            },
                            [
                              _c("strong", [
                                _vm._v(
                                  _vm._s(_vm.$t("page_editor.text_entry.title"))
                                )
                              ]),
                              _vm._v(" "),
                              !_vm.sourceEditAvaliable
                                ? _c(
                                    "span",
                                    { staticClass: "typography--caption" },
                                    [_vm._v("(수정 불가)")]
                                  )
                                : _vm._e()
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-9" }, [
                          _c("div", { staticClass: "float-right" }, [
                            _c(
                              "small",
                              {
                                staticClass:
                                  "typography--caption typography--color-secondary align-bottom"
                              },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm.$t("page_editor.text_entry.hint")
                                    ) +
                                    "\n                  "
                                )
                              ]
                            )
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("hr"),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          style: _vm.sourceEditAvaliable
                            ? ""
                            : "pointer-events: none;"
                        },
                        [
                          _vm._l(_vm.answers, function(answer, index) {
                            return _c(
                              "div",
                              { key: _vm.getAnswerKey(answer) },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "quiz-answer-box",
                                    class: {
                                      "has-error":
                                        answer.content &&
                                        answer.content.length > 499
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: index > 0,
                                            expression: "index > 0"
                                          }
                                        ],
                                        staticClass:
                                          "delete-quiz-answer-btn clickable",
                                        on: {
                                          click: function($event) {
                                            return _vm.removeAnswer(index)
                                          }
                                        }
                                      },
                                      [
                                        _c("img", {
                                          attrs: {
                                            src:
                                              "/static/images/icon-delete.svg",
                                            alt: "delete quiz answer choice"
                                          }
                                        })
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "quiz-text-entry-editor" },
                                      [
                                        _c("AutosizeTextarea", {
                                          attrs: {
                                            placeholder: _vm.$t(
                                              "page_editor.text_entry.placeholder"
                                            )
                                          },
                                          model: {
                                            value: answer.content,
                                            callback: function($$v) {
                                              _vm.$set(answer, "content", $$v)
                                            },
                                            expression: "answer.content"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _vm.isPublisherUser && !answer.is_correct
                                      ? _c("div", [_vm._v("오답")])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.isPublisherUser && answer.criteria
                                      ? _c("div", [
                                          _vm._v(
                                            _vm._s(
                                              "관리자 설정 (" +
                                                answer.criteria +
                                                ")"
                                            )
                                          )
                                        ])
                                      : _vm._e()
                                  ]
                                ),
                                _vm._v(" "),
                                answer.content && answer.content.length > 499
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "typography--caption typography--color-alert text-center pb-12"
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.$t(
                                                "page_editor.choices.alerts.max_length"
                                              )
                                            ) +
                                            "\n                "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            )
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.answers.length < 5,
                                  expression: "answers.length < 5"
                                }
                              ],
                              on: {
                                click: function($event) {
                                  return _vm.addNewAnswer(true)
                                }
                              }
                            },
                            [
                              _c("AddAnswerButton", [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.$t(
                                        "page_editor.text_entry.add_new.placeholder"
                                      )
                                    ) +
                                    "\n                "
                                )
                              ])
                            ],
                            1
                          )
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _vm.isPublisherUser
                        ? [
                            _c("br"),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "row" },
                              [
                                _c("div", { staticClass: "col-12" }, [
                                  _c(
                                    "h6",
                                    {
                                      staticClass:
                                        "typography--body-1 typography--color-secondary"
                                    },
                                    [_c("strong", [_vm._v("정답기준")])]
                                  )
                                ]),
                                _vm._v(" "),
                                _vm._l(_vm.answerCriteriaTypes, function(
                                  answerCriteria,
                                  index
                                ) {
                                  return _c(
                                    "div",
                                    { key: index, staticClass: "col-12" },
                                    [
                                      _c(
                                        "Checkbox",
                                        {
                                          attrs: {
                                            "model-value":
                                              _vm.selectedAnswerCriteriaTypes,
                                            "check-value": answerCriteria.value
                                          },
                                          on: {
                                            change: _vm.selectAnswerCriteria
                                          }
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "typography--body-3 typography--color-secondary",
                                              attrs: { slot: "label" },
                                              slot: "label"
                                            },
                                            [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(answerCriteria.label) +
                                                  "\n                    "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                })
                              ],
                              2
                            )
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.pageType === "essay_type"
                ? _c("div", { staticClass: "quiz-score-allotment-container" }, [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-3" }, [
                        _c(
                          "h6",
                          {
                            staticClass:
                              "typography--body-1 typography--color-secondary"
                          },
                          [
                            _c("strong", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("page_editor.score_allotment.title")
                                )
                              )
                            ])
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-9" }, [
                        _c("div", { staticClass: "float-right" }, [
                          _c(
                            "small",
                            {
                              staticClass:
                                "typography--caption typography--color-secondary align-bottom"
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm.$t("page_editor.score_allotment.hint")
                                  ) +
                                  "\n                  "
                              )
                            ]
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("hr"),
                    _vm._v(" "),
                    _c(
                      "div",
                      [
                        _c(
                          "b-dropdown",
                          {
                            staticClass: "score-select-dropdown",
                            attrs: {
                              text: _vm.$t("common.numeric_score", {
                                n: _vm.quiz.score
                              })
                            }
                          },
                          _vm._l(10, function(n) {
                            return _c(
                              "b-dropdown-item",
                              {
                                key: n,
                                on: {
                                  click: function($event) {
                                    _vm.quiz.score = n
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.$t("common.numeric_score", { n: n })
                                    ) +
                                    "\n                "
                                )
                              ]
                            )
                          }),
                          1
                        )
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.pageType === "essay_type"
                ? _c(
                    "div",
                    { staticClass: "quiz-grading-keywords-container" },
                    [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-3" }, [
                          _c(
                            "h6",
                            {
                              staticClass:
                                "typography--body-1 typography--color-secondary"
                            },
                            [
                              _c("strong", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("page_editor.grading_keywords.title")
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "small",
                                { staticClass: "typography--color-disabled" },
                                [_vm._v(_vm._s(_vm.$t("common.optional")))]
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-9" }, [
                          _c("div", { staticClass: "float-right" }, [
                            _c(
                              "small",
                              {
                                staticClass:
                                  "typography--caption typography--color-secondary align-bottom"
                              },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm.$t(
                                        "page_editor.grading_keywords.hint"
                                      )
                                    ) +
                                    "\n                  "
                                )
                              ]
                            )
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("hr"),
                      _vm._v(" "),
                      _c("InputTag", {
                        class: {
                          "no-grading-keyword": _vm.gradingKeywords.length === 0
                        },
                        attrs: {
                          tags: _vm.gradingKeywords,
                          placeholder: _vm.$t(
                            _vm.gradingKeywords.length > 0
                              ? "page_editor.grading_keywords.short_placeholder"
                              : "page_editor.grading_keywords.long_placeholder"
                          )
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.pageType !== "non_quiz" && _vm.quiz
                ? _c(
                    "div",
                    { staticClass: "quiz-description-container" },
                    [
                      _vm.pageType !== "essay_type"
                        ? _c(
                            "h6",
                            {
                              staticClass:
                                "typography--body-1 typography--color-secondary"
                            },
                            [
                              _c("strong", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("page_editor.description.title")
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              !_vm.sourceEditAvaliable
                                ? _c(
                                    "span",
                                    { staticClass: "typography--caption" },
                                    [_vm._v("(수정 불가)")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "small",
                                { staticClass: "typography--color-disabled" },
                                [_vm._v(_vm._s(_vm.$t("common.optional")))]
                              )
                            ]
                          )
                        : _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-3" }, [
                              _c(
                                "h6",
                                {
                                  staticClass:
                                    "typography--body-1 typography--color-secondary"
                                },
                                [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("page_editor.description.title")
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "small",
                                    {
                                      staticClass: "typography--color-disabled"
                                    },
                                    [_vm._v(_vm._s(_vm.$t("common.optional")))]
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-9" }, [
                              _c("div", { staticClass: "float-right" }, [
                                _c(
                                  "small",
                                  {
                                    staticClass:
                                      "typography--caption typography--color-secondary align-bottom"
                                  },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.$t(
                                            "page_editor.description.essay_type_hint"
                                          )
                                        ) +
                                        "\n                  "
                                    )
                                  ]
                                )
                              ])
                            ])
                          ]),
                      _vm._v(" "),
                      _c("hr"),
                      _vm._v(" "),
                      _vm.pageType !== "essay_type"
                        ? _c("BaseEditor", {
                            staticClass: "quiz-editor",
                            attrs: {
                              "editor-id": "quiz-desc-editor-" + _vm.id,
                              "text-limit": 5000,
                              disabled: !_vm.sourceEditAvaliable,
                              placeholder: _vm.$t(
                                "page_editor.description.placeholder"
                              )
                            },
                            on: { error: _vm.checkDescriptionError },
                            model: {
                              value: _vm.quiz.description,
                              callback: function($$v) {
                                _vm.$set(_vm.quiz, "description", $$v)
                              },
                              expression: "quiz.description"
                            }
                          })
                        : _c(
                            "div",
                            { staticClass: "essay-type-desc-editor" },
                            [
                              _c("AutosizeTextarea", {
                                attrs: {
                                  limit: 5000,
                                  placeholder: _vm.$t(
                                    "page_editor.description.placeholder"
                                  )
                                },
                                model: {
                                  value: _vm.quiz.description,
                                  callback: function($$v) {
                                    _vm.$set(_vm.quiz, "description", $$v)
                                  },
                                  expression: "quiz.description"
                                }
                              })
                            ],
                            1
                          )
                    ],
                    1
                  )
                : _vm._e()
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { attrs: { slot: "modal-footer" }, slot: "modal-footer" })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-72b6f80e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-72b6f80e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/my-cards/components/PageEditorModal.vue
// module id = xYl9
// module chunks = 1